/**
 * Products domain config — COMMERCE-WORKSPACE-FRAMEWORK-000001 reference.
 * Presentation only; page owns MarketSync fetch. No invented metrics.
 */
import type { CommerceWorkspaceConfig, QuickFilterOption, ToolbarSelectOption } from '../../commerce-workspace';
import type { CatalogProduct } from '../../api/amazonconnect';

export const PRODUCT_STATUS_OPTS = ['', 'DISCOVERABLE', 'BUYABLE', 'NOT_DISCOVERABLE', 'DELETED'] as const;

export const PRODUCT_QUICK_STATUS: QuickFilterOption[] = [
  { id: 'all', label: 'All', value: '' },
  { id: 'disc', label: 'Discoverable', value: 'DISCOVERABLE' },
  { id: 'buy', label: 'Buyable', value: 'BUYABLE' },
  { id: 'nd', label: 'Not discoverable', value: 'NOT_DISCOVERABLE' },
  { id: 'del', label: 'Deleted', value: 'DELETED' },
];

export const PRODUCT_STATUS_TOOLBAR_OPTIONS: ToolbarSelectOption[] = PRODUCT_STATUS_OPTS.map((s) => ({
  value: s,
  label: s || 'All statuses',
}));

export const productsWorkspaceConfig: CommerceWorkspaceConfig<CatalogProduct> = {
  domain: 'catalog',
  title: 'Products',
  subtitle:
    'Listing identity and content from MarketSync catalog. Price and inventory open peer workspaces — no dual ownership. Reference workspace for Inventory / Orders / Pricing / Finance.',
  entryKey: 'ASIN / SKU',
  gridId: 'product-catalog-v3',
  density: 'compact',
  emptyMessage:
    'No products. Complete Seller Identity, run Catalog full sync on Connect, then refresh.',
  dataSourceBadge: 'MarketSync · catalog',
  defaultSort: 'sku',
  defaultOrder: 'asc',
  defaultPageSize: 25,
  quickFilters: PRODUCT_QUICK_STATUS,
  toolbarFilters: [
    {
      id: 'status',
      label: 'Status',
      options: PRODUCT_STATUS_TOOLBAR_OPTIONS,
    },
  ],
};
